import { useClassifierServiceGetCommonClassifierElementListEndpoint } from 'src/api/queries'
import { ClassifierCategory, ClassifierType } from 'src/api/requests'
import { useClassifierId } from 'src/hooks'

import { DISEASE_OUTCOME_KEYS } from './constants'

/** "Finalul bolii" classifier elements: all of them, the ones still offered on
 *  the forms (not retired), and a check whether an element is death. */
export const useDiseaseOutcomeOptions = () => {
  const diseaseOutcomeId = useClassifierId(
    ClassifierType.DISEASE_OUTCOME,
    ClassifierCategory.TREATMENT
  )

  const { data } = useClassifierServiceGetCommonClassifierElementListEndpoint(
    { id: String(diseaseOutcomeId), pageSize: 100 },
    [diseaseOutcomeId],
    { enabled: !!diseaseOutcomeId }
  )

  const options = data?.data
  const activeOptions = options?.filter(
    (item) => item.originalValue !== DISEASE_OUTCOME_KEYS.retired
  )

  const isDeath = (id?: string | null) =>
    !!id &&
    options?.find((item) => item.id === id)?.originalValue ===
      DISEASE_OUTCOME_KEYS.death

  return { options, activeOptions, isDeath, isLoaded: !!options }
}
